import { getApiCall, postApiCall } from '../../utils/request';
import {
    SET_ACTIVE_BTN, GET_ADMIN_TEST, GET_NEXT_ADMIN_TEST, GET_ADMIN_V2_TEST, RESET_TEST_LOADING, ACTION_DONE,
    SEARCH_QUIZ, GET_QUIZZES,
    SEARCH_TEST, GET_CUSTOM_TESTS, Add_Question_Quiz, Delete_Question_Quiz, Delete_All_Question_Quiz, CHANGE_TEST_STATUS,
    GET_QUESTION_SKILLS, SEARCH_SKILLS, BACK_TO_VIEW, GET_QUESTIONS_FROM_SKILL, SEARCH_QUESTION, UPDATE_QUESTION,
    RESET_QUES_DATA, SET_QUESTION_TITLE, SET_EXPLAINTION, SET_CHOICE1, SET_CHOICE2, SET_CHOICE3, SET_CHOICE4, GET_DATA_FOR_EDIT,
} from "../../actionType/type";
import { returnErrors } from '../errorAction';

export const setActive = (active) => async (dispatch) => {
    return dispatch({ type: SET_ACTIVE_BTN, payload: active })
}

export const getTestList = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/test/list?page=${page}`);
        dispatch({ type: GET_ADMIN_TEST, payload: response.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const getNextTest = (page) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/test/list?page=${page}`);
        dispatch({ type: GET_NEXT_ADMIN_TEST, payload: response.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const getV2TestList = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/test/results`);
        dispatch({ type: GET_ADMIN_V2_TEST, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const resetTestLoading = () => async (dispatch) => {
    return dispatch({ type: RESET_TEST_LOADING })
}

export const testAction = (obj) => async (dispatch) => {

    try {
        const response = await postApiCall(`admin/test/approve`, obj);
        if (response.data.success) {
            const credit = response.data.test_credit
            dispatch({ type: ACTION_DONE, payload: { credit, obj } });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

//quizzesvar

export const getSearchQuiz = (val) => async (dispatch) => {
    return dispatch({ type: SEARCH_QUIZ, payload: val })
}



export const getQuizzes = (id) => async (dispatch) => {
    try {
        let response
        if (id) {
            response = await getApiCall(`admin/custom/quiz/list?skill_id=${id}`);
        } else {
            response = await getApiCall(`admin/custom/quiz/list`);
        }
        dispatch({ type: GET_QUIZZES, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const addQuiz = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/quiz/add`, obj);
        if (response.data.success) {
            // dispatch({ type: "Add_Question_Quiz", payload: { ...data, tags: obj.tags } });
            returnErrors(dispatch, 'Quiz added', response?.status);
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
}

export const updateQuiz = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/quiz/edit`, obj);
        if (response.data.success) {
            returnErrors(dispatch, 'Quiz updated', response?.status);
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
}

export const changeQuizStatus = (id, active, type = 'Quiz') => async (dispatch) => {

    try {
        const response = await postApiCall(`admin/custom/quiz/toggle`, { _id: id });
        if (response.data.success) {
            returnErrors(dispatch, active ? 'Quiz is deactivated' : 'Quiz is activated', response?.status)
            dispatch({ type: CHANGE_TEST_STATUS, payload: { id, active, type } });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};



//tests

export const getCustomTests = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/custom/test/list`);
        dispatch({ type: GET_CUSTOM_TESTS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const getSearchTest = (val) => async (dispatch) => {
    return dispatch({ type: SEARCH_TEST, payload: val })
}

export const addQuizQuestions = (data) => async (dispatch) => {
    dispatch({ type: Add_Question_Quiz, payload: data });
}

export const selectQuestions = (data) => async (dispatch) => {
    dispatch({ type: Delete_Question_Quiz, payload: data });
};


export const deleteQuizQuestions = () => async (dispatch) => {
    dispatch({ type: Delete_All_Question_Quiz });
};

export const changeTestStatus = (id, active, type = 'Test') => async (dispatch) => {

    try {
        const response = await postApiCall(`admin/custom/test/activate`, { _id: id });
        if (response.data.success) {
            returnErrors(dispatch, active ? "Test is deactivated" : 'Test is activated', response?.status)
            dispatch({ type: CHANGE_TEST_STATUS, payload: { id, active, type } });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const addCustomTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/test/add`, obj);
        if (response.data.success) {
            // dispatch({ type: "Add_Question_Quiz", payload: { ...data, tags: obj.tags } });
            returnErrors(dispatch, 'Test added', response?.status);
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
}

export const editCustomTest = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/test/edit`, obj);
        if (response.data.success) {
            returnErrors(dispatch, 'Test updated', response?.status);
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
}




//Question bank


export const backToView = () => async (dispatch) => {
    dispatch({
        type: BACK_TO_VIEW
    })
}

export const getSkills = () => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/custom/question/skills`);
        dispatch({ type: GET_QUESTION_SKILLS, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const getSearchSkill = (val) => async (dispatch) => {
    dispatch({
        type: SEARCH_SKILLS, payload: val
    })
}



export const getQuestionFromSkill = (id) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/custom/question/list?skill=${id}`);
        const data = response.data.data
        dispatch({ type: GET_QUESTIONS_FROM_SKILL, payload: { data, id } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const getSearchQuestion = (val) => async (dispatch) => {
    dispatch({
        type: SEARCH_QUESTION, payload: val
    })
}




export const resetQuestionData = () => async (dispatch) => {
    dispatch({
        type: RESET_QUES_DATA
    })
}

export const setTitle = (val) => async (dispatch) => {
    dispatch({
        type: SET_QUESTION_TITLE,
        payload: val
    })
}

export const setExplanation = (val) => async (dispatch) => {
    dispatch({
        type: SET_EXPLAINTION,
        payload: val
    })
}

export const setChoice1 = (val) => async (dispatch) => {
    return dispatch({
        type: SET_CHOICE1,
        payload: val
    })
}

export const setChoice2 = (val) => async (dispatch) => {
    return dispatch({
        type: SET_CHOICE2,
        payload: val
    })
}

export const setChoice3 = (val) => async (dispatch) => {
    return dispatch({
        type: SET_CHOICE3,
        payload: val
    })
}

export const setChoice4 = (val) => async (dispatch) => {
    return dispatch({
        type: SET_CHOICE4,
        payload: val
    })
}

export const savedQuestions = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/question/add`, obj);
        if (response.data.success) {
            if (obj.isAddQuiz === true) {
                const data = response.data.data
                dispatch({ type: "Add_Question_Quiz", payload: { ...data, tags: obj.tags } });
                returnErrors(dispatch, 'Question added', response?.status);
            } else {
                returnErrors(dispatch, 'Question added ', response?.status);
            }
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
};

export const editedQuestion = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/custom/question/edit`, obj);
        if (response.data.success) {
            if (obj.isAddQuiz === true) {
                const data = response.data.data
                dispatch({ type: "Add_Question_Quiz", payload: { ...data, tags: obj.tags } });

            } else {
                dispatch({ type: UPDATE_QUESTION, payload: obj });
                returnErrors(
                    dispatch, 'Question updated ', response?.status)
            }
        } else {
            returnErrors(
                dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error?.response.data?.message, error.response?.status);
    }
};


export const getDataForEdit = (data, type) => async (dispatch) => {
    try {

        dispatch({ type: GET_DATA_FOR_EDIT, payload: { data, type } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data?.message, error.response?.status);
    }
};
